import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import NavCategoryBar from '../NavCategoryBar/NavCategoryBar';
import SubNav from '../SubNav/SubNav';
import { SubNavWrapper } from './bottomNavStyles';
import transformHref from 'core/utils/transformHref';

class BottomNavLogic extends PureComponent {
	barTimeout = undefined
	categoryTimeout = undefined

	onMouseLeave = () => {
		this.barTimeout = setTimeout(() => {
			if (this.props.mouseElementName === 'categoryBar') {
				this.props.changeMouseElementName(null);
				this.props.changeSlug(null);
			}
		}, 200);
	};

	onMouseEnter = () => {
		if (! this.props.enabled) return;
		if (this.barTimeout) {
			window.clearTimeout(this.barTimeout);
		}

		if (this.props.mouseElementName !== 'categoryBar') {
			this.props.changeMouseElementName('categoryBar');
		}
	};

	categoryMouseEnter = (slug, navItem) => e => {
		const { enabled, subnavSlug, changeSlug } = this.props;
		if (! enabled) return;

		// dont fire the action if the slug is already up to date
		if (slug === subnavSlug) return;

		this.categoryTimeout = window.setTimeout(() => {
			changeSlug(slug, navItem);
		}, 200);
	};

	categoryMouseLeave = () => {
		if (this.categoryTimeout) {
			clearTimeout(this.categoryTimeout);
		}
	};

	subNavMouseEnter = () => {
		if (! this.props.enabled) return;
		this.props.changeMouseElementName('subNav');
	};

	subNavMouseLeave = () => {
		window.setTimeout(() => {
			if (this.props.mouseElementName === 'subNav') {
				this.props.changeMouseElementName(null);
				this.props.changeSlug(null);
			}
		}, 200);
	};

	render () {
		const { slug, contentful } = this.props;

		const activeItemArray = this.props.navigationItems.filter(navItem => navItem.slug === slug);
		const activeItem = activeItemArray.length > 0 ? activeItemArray[0] : {};
		const { imageTitle, shortName, iconSize, children, accentColor, href, type, ads } = activeItem;

		const newHref = (typeof href === "undefined" || href === null) ? transformHref({ slug, type }) : href;
		const svgProps = { imageTitle: imageTitle || shortName, href: newHref, slug, accentColor };

		const subNavProps = {
			slug: slug,
			accentColor: accentColor,
			svgProps: svgProps,
			onMouseEnter: this.subNavMouseEnter,
			onMouseLeave: this.subNavMouseLeave,
			iconSize: iconSize,
			metaChildren: children,
			type: type,
			href: newHref,
			ads: ads,
		};

		return (
			<Fragment>
				<NavCategoryBar
					{ ...this.props }
					onMouseEnter={this.onMouseEnter}
					onMouseLeave={this.onMouseLeave}
					categoryMouseEnter={this.categoryMouseEnter}
					categoryMouseLeave={this.categoryMouseLeave}
					accentColor={accentColor}
				/>
				{slug && subNavProps['metaChildren'] && subNavProps['metaChildren'].length > 0 && (
					<SubNavWrapper>
						<SubNav { ...subNavProps } contentful={contentful} />
					</SubNavWrapper>
				)}
			</Fragment>
		);
	}

	static propTypes = {
		mouseElementName: PropTypes.string,
		enabled: PropTypes.bool,
		subnavSlug: PropTypes.string,
		slug: PropTypes.string,
		changeSlug: PropTypes.func,
		changeMouseElementName: PropTypes.func,
		contentful: PropTypes.bool,
		navigationItems: PropTypes.array,
	}
}

export default BottomNavLogic;
